const FILES_BASE_URL = import.meta.env.VITE_FILES_BASE_URL || 'https://www.cabaza.be/files';

/**
 * « Comment ça marche » — une suite d'étapes numérotées.
 *
 * Le numéro est calculé au rendu, jamais saisi : renuméroter à la main
 * après avoir inséré une étape est le genre d'oubli qui se voit.
 *
 * ========================================================================
 * DEUX CHAMPS OPTIONNELS, AJOUTÉS POUR LA PAGE D'INSTALLATION
 * ========================================================================
 *
 * `astuce` et `image` sont facultatifs : les blocs écrits avant leur
 * existence s'affichent exactement comme avant. C'est la raison d'avoir
 * enrichi ce bloc plutôt que d'en créer un second — deux blocs qui font
 * presque la même chose divergent, et c'est celui qu'on oublie de corriger
 * qui finit par mentir.
 *
 * `astuce` porte une mise en garde qui doit ARRÊTER LE LECTEUR : sur la page
 * d'installation, « cette méthode ne fonctionne qu'avec Safari » évite à
 * quelqu'un sous Chrome iOS de chercher un bouton qui n'existe pas. D'où le
 * fond ambré plutôt qu'un simple texte gris.
 */
const EtapesBloc = ({ bloc }) => {
    const etapes = Array.isArray(bloc?.etapes) ? bloc.etapes : [];
    if (etapes.length === 0) return null;

    return (
        <section className="mb-10" data-testid="bloc-etapes">
            {bloc.titre && (
                <h2 className="text-xl font-bold text-gray-900 mb-5">{bloc.titre}</h2>
            )}
            {bloc.sousTitre && (
                <p className="text-sm text-gray-600 -mt-3 mb-5">{bloc.sousTitre}</p>
            )}
            <ol className="space-y-4">
                {etapes.map((e, i) => (
                    <li key={i} className="flex gap-4">
                        <span className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold text-white bg-gradient-to-br from-cabaza-purple to-cabaza-pink">
                            {i + 1}
                        </span>
                        <div className="pt-0.5 min-w-0 flex-1">
                            {e.titre && (
                                <h3 className="font-semibold text-gray-900">{e.titre}</h3>
                            )}
                            {e.texte && (
                                <p className="text-sm text-gray-600 mt-0.5">{e.texte}</p>
                            )}

                            {e.astuce && (
                                <p className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 mt-2">
                                    {e.astuce}
                                </p>
                            )}

                            {/* L'image est décorative : elle illustre un geste déjà
                                décrit par le texte. Un alt vide évite de faire lire
                                deux fois la même chose à un lecteur d'écran. */}
                            {e.image && (
                                <img
                                    src={e.image.startsWith('http') || e.image.startsWith('/')
                                        ? e.image
                                        : `${FILES_BASE_URL}/${e.image}`}
                                    alt=""
                                    loading="lazy"
                                    className="mt-3 rounded-lg border max-w-full h-auto"
                                />
                            )}
                        </div>
                    </li>
                ))}
            </ol>
        </section>
    );
};

export default EtapesBloc;
